import { getSpeaker, getLikesCount } from '../views/reactViews/ApiUtil';
import { checkIfHasError } from '../views/reactViews/ApiUtil';
import { toggleMarker, fetchAgendaSettings, fetchMarkers } from '../actions/AgendaActions';
import {
    shouldFetchAgendaSettingsSelector,
    shouldFetchMarkersSelector,
    agendaSpeakerSelector,
    fillSpeakers
} from '../selectors/AgendaSelectors';
import { fetchSessionsFromApi } from './helpers';

import {
    IS_SPEAKER_LOADING,
    UPDATE_SPEAKER_LIKES,
    SET_AGENDA_SPEAKER_SESSIONS,
    SET_AGENDA_SPEAKER,
    SET_AGENDA_SPEAKER_LIKE_COUNT,
    RESET_SPEAKER_DATA,
    START_UPDATE_LIKE_SPEAKER_STATUS,
    FAILED_UPDATE_LIKE_SPEAKER_STATUS
} from '../constants/ActionTypes';

const setLoadingAction = isLoading => ({
    type: IS_SPEAKER_LOADING,
    isLoading
});

export const updateLikeSpeakerStatus = type => ({ type });

export const updateLikeCounterAction = delta => ({ type: UPDATE_SPEAKER_LIKES, payload: { delta }});

export const updateLikeCounter = isLiked => {
    const delta = isLiked ? -1 : 1;
    return updateLikeCounterAction(delta);
};

export const likeSpeakerToggle = (markerProps, isLiked) => async(dispatch, getState) => {
    try {
        dispatch(updateLikeSpeakerStatus(START_UPDATE_LIKE_SPEAKER_STATUS));
        const result = await toggleMarker(markerProps)(dispatch, getState);
        dispatch(updateLikeCounter(isLiked));
        return result;
    } catch (err) {
        dispatch(updateLikeSpeakerStatus(FAILED_UPDATE_LIKE_SPEAKER_STATUS));
        throw err;
    }
};

const setSessionsAction = sessions => ({ type: SET_AGENDA_SPEAKER_SESSIONS, sessions });

const setSpeakerAction = speaker => ({ type: SET_AGENDA_SPEAKER, speaker });

const resetSpeakerDataAction = () => ({ type: RESET_SPEAKER_DATA });

const setLikeCount = speakerLikesCount => ({ type: SET_AGENDA_SPEAKER_LIKE_COUNT, speakerLikesCount });

export const fetchSpeakerData = (speakerId, eventId) => async(dispatch, getState) => {
    try {
        dispatch(resetSpeakerDataAction());
        const state = getState();
        if (shouldFetchAgendaSettingsSelector(state)) {
            fetchAgendaSettings(eventId)(dispatch, getState);
        }
        fetchMarkers()(dispatch, getState);

        const speaker = agendaSpeakerSelector(state, { eventId, speakerId }) ||
            await getSpeaker({
                eventId,
                speakerId
            });

        const validatedSpeaker = checkIfHasError(speaker);
        dispatch(setSpeakerAction(validatedSpeaker));

        const [sessions, likeCount] = await Promise.all(
            [
                fetchSessionsFromApi(state)({ eventId, query: { speakers: [speakerId] } }),
                getLikesCount({eventId, entity: 'speakers', entityId: speakerId })
            ]
        );

        const validatedSessions = checkIfHasError(sessions);
        dispatch(setSessionsAction(validatedSessions));

        const validatedLikeCount = checkIfHasError(likeCount);
        dispatch(setLikeCount(validatedLikeCount));

        dispatch(setLoadingAction(false));
    } catch (err) {
        dispatch(setLoadingAction(false));
        throw err;
    }
};


export const searchBySpeaker = search => (_, getState) => {
    const s = search.toUpperCase();
    return fillSpeakers(getState())
        .filter(({ fullName, company }) => {
            const nameMatch = fullName.toUpperCase().includes(s);
            const companyMatch = (company || '').toUpperCase().includes(s);
            return nameMatch || companyMatch;
        });
};
